import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { TranslateService } from '../../shared/services/translate.service';

let nextId = 0;

/** Dood's "deeplink unavailable" block (glitching logo, copy, actions) shared by the page and the dialog. */
@Component({
  selector: 'mtm-content-unavailable-message',
  standalone: true,
  templateUrl: './content-unavailable-message.component.html',
  styleUrl: './content-unavailable-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentUnavailableMessageComponent {
  private readonly translateService = inject(TranslateService);

  readonly headingId = input.required<string>();
  readonly goHome = output<void>();
  readonly goBack = output<void>();

  protected readonly glitchLayers = ['gl-c', 'gl-m', 'gl-k'] as const;
  protected readonly facePath =
    'M70.5713 0C109.357 0.000712932 140.798 31.444 140.798 70.2292C140.797 91.9151 130.965 111.301 115.518 124.184V57.588L70.5713 88.9347L25.6248 57.588V124.187C10.1763 111.304 0.342531 91.9166 0.342133 70.2292C0.342133 31.4433 31.7855 0 70.5713 0Z';
  protected readonly eyesPath =
    'M41.7317 50.5623H55.777L33.3053 36.517L41.7317 50.5623ZM85.2774 50.5623H99.3227L107.749 36.517L85.2774 50.5623Z';
  // SVG ids are document-global; keep them unique when the page and the dialog render together.
  private readonly uid = nextId++;
  protected readonly clipId = `mtm-dl-clip-${this.uid}`;
  protected readonly patternId = `mtm-dl-pattern-${this.uid}`;

  protected translate(key: string): string {
    return this.translateService.data[key] || key;
  }
}
